import type { ProcessDto, ProcessStepDto } from '../api.ts';
import type { ProjectProcess } from './graph.ts';


/** The engine's view of a project's process, from what the API sends. */
export function processFromDto(dto: Pick<ProcessDto, 'kind' | 'steps' | 'links'> & { out?: string[] }): ProjectProcess {
  return {
    kind: dto.kind ?? 'client',
    ...(dto.out?.length ? { out: dto.out } : {}),
    steps: dto.steps.map((s) => ({
      id: s.id,
      key: s.key,
      instance: s.instance,
      kind: s.kind,
      title: s.title,
      parentId: s.parentId,
      state: s.state,
      days: s.days,
      off: s.off,
      startedOn: s.startedOn,
      doneOn: s.doneOn,
      // The phase it sits in, as the API read it (core `projectPhases`): a step's own phase wins, so a step come late or
      // one of the job's own is read in the phase it is in here as there.
      ...(s.phase ? { phase: s.phase } : {}),
    })),
    links: dto.links.map((l) => ({ stepId: l.stepId, needsId: l.needsId, kind: l.kind })),
  };
}

/** Latest planned dates, by step. */
export function plansFromDto(steps: ProcessStepDto[]): Map<string, string> {
  return new Map(steps.filter((s) => s.plan && s.state !== 'done').map((s) => [s.id, s.plan!.on]));
}

